angular
    .module('dnecom.component.cart')
    .directive('countCart', ["Cart", "CartUtils", "SignifyOnCartIconUtils", function (Cart, CartUtils, SignifyOnCartIconUtils) {
        var defaultClass = 'ies-hopping-cart-badge';

        return {
            scope: {
                cssClass: '@countCart'
            },

            link: function (scope, element, attr) {
                var updateTemplate = function (count, signifyNotification) {
                    if (count === 0 && signifyNotification === null) {
                        element.html('');
                        element.removeClass(scope.cssClass || defaultClass);
                    } else {
                        element.addClass(scope.cssClass || defaultClass);
                        element.html(count);
                    }
                };

                var update = function () {
                    var cartItemsCount = 0;
                    var signifyNotification = null;

                    Cart.alwaysGet().then(function(result) {
                        if (result.success) {
                            cartItemsCount = CartUtils.getCartTotalQuantity(result.cart);
                        }

                        if (cartItemsCount === 0) {
                            SignifyOnCartIconUtils.getAvailableSignifyNotification().then(function(result) {
                                if (result.success) {
                                    signifyNotification = result.signifyNotification;
                                }

                                updateTemplate(cartItemsCount, signifyNotification);

                                if (signifyNotification) {
                                    SignifyOnCartIconUtils.activateSignifyOnCartIcon(element, signifyNotification, attr.storeView);
                                }
                            });
                        } else {
                            updateTemplate(cartItemsCount, null);
                            SignifyOnCartIconUtils.deactivateSignifyOnCartIcon(element, signifyNotification, attr.storeView);
                        }
                    });
                };

                scope.$on('cart.update.end', update);
                update();
            }
        }
    }]);
